import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiPagehashesService from '@/services/banzai-pagehashes.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiPageHashes = new BanzaiPagehashesService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiPageHashes: BanzaiPagehashesService;
  }
}
